import {CDRDefinition, NumberingScheme} from 'molbio/antibody-engineering/AntibodyEngineeringConstants';
import {
  BulkCDRAnnotationResponse,
  BulkNumberingResponse,
  getCDRAnnotations as getCDRAnnotationsDAO,
  getNumbering as getNumberingDAO,
} from 'molbio/dao/AntibodyEngineeringDAO';
import notifications from 'notifications';
import * as net from 'util/Net';

export async function getNumbering(
  aminoAcids: Array<string>,
  scheme: NumberingScheme
): Promise<BulkNumberingResponse> {
  try {
    const response = await getNumberingDAO(aminoAcids, scheme);
    return response;
  } catch (e) {
    if (net.isServerRequestError(e)) {
      notifications.stickyNotifyForFriendlyError(e, 'antibody-numbering');
      return [];
    } else {
      throw e;
    }
  }
}

export async function getCDRAnnotations(
  aminoAcids: Array<string>,
  definition: CDRDefinition
): Promise<BulkCDRAnnotationResponse> {
  try {
    const response = await getCDRAnnotationsDAO(aminoAcids, definition);
    return response;
  } catch (e) {
    if (net.isServerRequestError(e)) {
      notifications.stickyNotifyForFriendlyError(e, 'antibody-cdr');
      return [];
    } else {
      throw e;
    }
  }
}
